import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import { Link } from "@argo/ui-elements";
import { colors, size, typography, breakpoints } from "@argo/principles";
import { activeState, focusState, rgba } from "@argo/utils";
import NavExpander from './NavExpander';
import { navbp, NAV_HEIGHT } from '../utils/constants';
import useAnalyticsClick from '../../../../analytics/react/useAnalyticsClick';
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
import SubNav from './SubNav';
var primary = colors.primary,
  blue = colors.blue;
var NavItem = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  flex-grow: 0;\n  display: inline-grid;\n  flex-direction: column;\n  position: relative;\n  a {\n    color: ", ";\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  > a,\n  label {\n    padding: ", "px;\n    display: block;\n  }\n  @media (min-width: ", "px) {\n    display: flex;\n  }\n  @media (min-width: ", "px) {\n    > a,\n    label {\n      padding-left: ", "px;\n      padding-right: ", "px;\n    }\n  }\n  @media (min-width: ", ") {\n    > a,\n    label {\n      display: inline-block;\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n      padding-left: ", "px;\n      padding-right: ", "px;\n    }\n    > ul {\n      overflow: hidden;\n      position: absolute;\n      padding: 0;\n      max-height: 0;\n      top: ", "px;\n      transition: 200ms ease-in;\n      transition-property: max-height, padding-bottom, padding-top;\n      li a {\n        height: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n        overflow: hidden;\n        transition: 200ms ease-in;\n        transition-property: height, padding-bottom, padding-top;\n      }\n    }\n    &:hover {\n      background: ", ";\n      transition: background 100ms ease-out;\n      > ul {\n        padding: ", "px 0;\n        max-height: 300px;\n        transition: 200ms cubic-bezier(.55, .1, 1, 1);\n        transition-property: max-height, padding-bottom, padding-top;\n        li a {\n          height: ", "px;\n          padding: ", "px 36px;\n          line-height: ", "px;\n          transition: 200ms cubic-bezier(.55, .1, 1, 1);\n          transition-property: height, padding-bottom, padding-top;\n          &:hover {\n            background-color: ", ";\n            padding-left: 31px;\n            border-left: 5px solid ", ";\n          }\n        }\n      }\n    }\n    &:last-of-type {\n      > ul {\n        right: 0;\n      }\n      > div, a, label {\n        padding-right: ", "px;\n      }\n    }\n    &:first-of-type {\n      > div, a, label {\n        padding-left: ", "px;\n      }\n    }\n    \n    > a {\n      ", "\n    }\n    ", "\n  }\n"])), typography.types.XSMedium, primary.white, primary.white, size.sm, breakpoints.md, breakpoints.lg, size.sm, size.sm, navbp.extraWideViewport, size.md, size.md, size.sm, size.sm, NAV_HEIGHT, blue.mutedBlue, size.sm, size.lg, size.xs, size.lg, rgba(primary.white, .2), blue.marineBlue, size.md, size.md, activeState, focusState);
var NavLinks = function NavLinks(_ref) {
  var links = _ref.links,
    isDesktopView = _ref.isDesktopView,
    pageId = _ref.pageId;
  var onAnalyticsClick = useAnalyticsClick();
  var triggerAnalytics = function triggerAnalytics(_ref2) {
    var googleTag = _ref2.googleTag,
      pixallTag = _ref2.pixallTag;
    return onAnalyticsClick(function () {
      var analyticsData = {
        event: 'analytics_event',
        eventElement: 'global-nav-header',
        eventAction: 'click',
        eventResult: googleTag,
        eventNonInteractive: false,
        eventData: {}
      };
      var pixallData = {
        event: 'pixall',
        eventSource: 'application',
        eventType: 'click',
        feature: 'global-nav-header',
        label: pixallTag,
        dealerCode: 'kbbcox',
        fullURL: window.location.href,
        program: 'DealerDotCom',
        wspCode: 'KBB',
        pageId: pageId
      };
      var result = {
        type: 'click'
      };
      if (googleTag) {
        result.googleAnalytics = {
          props: analyticsData
        };
      }
      if (pixallTag) {
        result.pixall = {
          props: pixallData
        };
      }
      return result;
    });
  };
  return links.map(function (link, i) {
    if (isDesktopView) {
      return React.createElement(NavItem, {
        "data-index": i,
        key: i
      }, React.createElement(Link, {
        "data-analytics": link.omnitureTag,
        "data-partner": link.partnerLink,
        "data-tag-id": "PrimaryNavList".concat(i),
        "data-index": i,
        type: 'unstyled',
        onClick: triggerAnalytics({
          googleTag: link === null || link === void 0 ? void 0 : link.googleTag,
          pixallTag: link === null || link === void 0 ? void 0 : link.pixallTag
        }),
        href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(link.url)
      }, link.name), link.dropdownItems && link.dropdownItems.length > 0 && React.createElement(SubNav, {
        menuIndex: i,
        menuItems: link.dropdownItems,
        triggerAnalytics: triggerAnalytics
      }));
    } else {
      if (link.dropdownItems && link.dropdownItems.length > 0) {
        return React.createElement(NavItem, {
          "data-index": i,
          key: i
        }, React.createElement(NavExpander, {
          link: link
        }, React.createElement(SubNav, {
          menuIndex: i,
          menuItems: link.dropdownItems,
          triggerAnalytics: triggerAnalytics
        })));
      } else {
        return React.createElement(NavItem, {
          "data-index": i,
          key: i
        }, React.createElement(Link, {
          "data-analytics": link.omnitureTag,
          "data-partner": link.partnerLink,
          "data-tag-id": "PrimaryNavList".concat(i),
          "data-index": i,
          type: 'unstyled',
          href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(link.url)
        }, link.name));
      }
    }
  });
};
export default React.memo(NavLinks, function (_ref3) {
  var links = _ref3.links;
  return links && links.length;
});